<template>
  <div class="col mx-0 px-0 py-1">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="getDetailsGroupe(id_groupe)"
          outlined
          x-small
          fab
          dark
          class="red"
          :loading="loading"
          v-on="on"
        >
          <v-icon>mdi-alert-circle</v-icon>
        </v-btn>
      </template>
      <span>Vérifier</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    parcours_effectif: {
      required: true,
    },
    animateur: {
      required: true,
    },
    user: {
      required: true,
    },
    id_groupe: {
      required: true,
    },
  },
  data() {
    return {
      groupe: null,
      loading: false,
      dialog: false,
    };
  },
  methods: {
    verifierParcours() {
      var self = this;
      //console.log(self.parcours_effectif.id);
      var objet = {
        verified: true,
        verifiedBy: self.user.displayName,
        verifiedDate: self.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
      var ref = this.$firebase
        .firestore()
        .collection("parcours_effectif")
        .doc(self.parcours_effectif.id);

      ref.set(objet, { merge: true });
      console.log("Vérification ajoutée")
      this.$emit('recharger')
    },
    reparerParcours(groupe) {
      var self = this;
      var objet = {
        id_responsable: groupe.responsable,
        nom_responsable: groupe.nom_responsable,
        verified: true,
        verifiedBy: self.user.displayName,
        verifiedDate: self.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
      //console.log(groupe);
      //console.log(self.parcours_effectif.id);
      //console.log(objet)

      //réparer ParcoursEffectif
      var batch = this.$firebase.firestore().batch();
      batch.set(
        this.$firebase
          .firestore()
          .collection("parcours_effectif")
          .doc(self.parcours_effectif.id),
        objet,
        { merge: true }
      );
      //réparer présences de la Formation

      batch.commit().then(() => {
        /** update etapes_effectives */
        const etapes_effectives = self.$firebase
          .firestore()
          .collection("etapes_effectives");
        etapes_effectives
          .where(
            "parcours_effectif_id_parcours_effectif",
            "==",
            self.parcours_effectif.id
          )
          .get()
          .then((snapshots) => {
            console.log("Etapes effectives successfully updated!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                etapes_effectives.doc(snap.id).set(objet, { merge: true });
              });
            } else {
              console.log("no snap Etapes effectives");
            }
          });
        /** End update Etapes effectives */

        /** update Fiches */
        const fiches = self.$firebase.firestore().collection("fiches");
        fiches
          .where(
            "parcours_effectif_id_parcours_effectif",
            "==",
            self.parcours_effectif.id
          )
          .get()
          .then((snapshots) => {
            console.log("Fiches successfully updated!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                fiches.doc(snap.id).set(objet, { merge: true });
              });
            } else {
              console.log("no snap Fiches");
            }
          });
        /** End update Fiches*/
        self.$emit('recharger')
        self.groupe = null;
        self.loading = false;
      });
    },
    getDetailsGroupe(id_groupe) {
      var self = this;
      self.loading = true;
      self.dialog = true;
      var docRef = this.$firebase
        .firestore()
        .collection("groupes")
        .doc(id_groupe);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            self.groupe = doc.data();
            var text =
              "Amimateur du groupe : " +
              self.groupe.nom_responsable +
              "<br /> Animateur de la formation :" +
              self.parcours_effectif.nom_responsable;
            console.log("ide_groupe :", self.id_groupe);

            if (
              self.groupe.responsable != self.parcours_effectif.id_responsable
            ) {
              self
                .$confirm(text, {
                  title: "Réparer?",
                  buttonTrueText: "Réparer",
                })
                .then((res) => {
                  if (res) {
                    self.reparerParcours(self.groupe);
                  }
                });
            } else {
              self
                .$confirm("Cette campagne est conforme", {
                  title: "Tout va bien",
                  buttonTrueText: "Continuer",
                })
                .then((res) => {
                  if (res) {
                    self.groupe = null;
                    self.verifierParcours();
                  }
                });
            }

            self.loading = false;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document! groupe");
            self.$confirm("Ce groupe n'existe plus").then((res) => {
              if (res) {
                self.groupe = null;
                self.verifierParcours();
              }
            });
            self.loading = false;
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
          self.loading = false;
        });
    },
  },
};
</script>
<style scoped></style>
